module.exports = __webpack_public_path__ + "static/media/prodejhw.219a5fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/prodejhw.jpg
// module id = 355
// module chunks = 0